import { render, staticRenderFns } from "./MyQuestionnaireListBadge.vue?vue&type=template&id=6ecd9d82"
import script from "./MyQuestionnaireListBadge.vue?vue&type=script&lang=js"
export * from "./MyQuestionnaireListBadge.vue?vue&type=script&lang=js"
import style0 from "./MyQuestionnaireListBadge.vue?vue&type=style&index=0&id=6ecd9d82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports